/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const qnaRef = con.eventDB.collection(cn).doc('UserVideoActivity').collection('Session')
var sessionRef = con.eventDB.collection(cn).doc("SessionList").collection("Sessions");
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var userEventsRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id).collection('UserEvents');


export default {
    fetchQnAs(context, session) {
        return new Promise((resolve, reject) => {
            let markers = []
            if(session.SessionId)
            { 
                //qnaRef.get().then(querySnapshot => {
                    //querySnapshot.docs.forEach(doc => {
                        qnaRef.doc(`${session.SessionId}`).collection('QnA').orderBy("CreatedDate", "desc").get().then(snapshot => {
                            snapshot.docs.forEach(docQnA => {
                                //context.dispatch('getUserDetailById', docQnA.data().CreatedBy).then(userDetail => {                                
                                    let docObj = docQnA.data()                                
                                    //docObj.CreatedByDetail = userDetail
                                    markers.push(docObj)
                                //})
                            })
                            context.commit('SET_QNAS', markers)
                                resolve(markers)
                        })                   
                    //})                
                //})
            }
            else
            {
                context.commit('SET_QNAS', markers)
                    resolve(markers)
            }
            
        })
    },
    fetchQnAsP(context, session) {
        return new Promise((resolve, reject) => {
            let markers = []
            if(session.SessionId)
            {
                //qnaRef.get().then(querySnapshot => {
                    //querySnapshot.docs.forEach(doc => {
                        qnaRef.doc(`${session.SessionId}`).collection('QnA').orderBy("CreatedDate", "desc").get().then(snapshot => {
                            snapshot.docs.forEach(docQnA => {
                                //context.dispatch('getUserDetailById', docQnA.data().CreatedBy).then(userDetail => {
                                    if(docQnA.data().Approved)
                                    {
                                        let docObj = docQnA.data()                                
                                            //docObj.CreatedByDetail = userDetail
                                            markers.push(docObj)                                
                                        
                                    }
                                    
                                //})
                            })
                            context.commit('SET_QNASP', markers)
                                resolve(markers)
                        })                   
                    //})                
                //})
            }
            else
            {
                context.commit('SET_QNASP', markers)
                    resolve(markers)
            }
            
        })
    },
    getUserDetailById(context, UserId) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": "",
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": {
                    UserId: `${UserId}`
                }
            }
            axios.post(CheckUserValidAPI, requestData, { headers: headers }).then(snapShot => {
                if (snapShot.data.userStatus) {
                    let doc = snapShot.data.result;
                    resolve(doc)
                }
                else {
                    resolve(null)
                }
            }).catch(err=>{ reject(err) })
        })
    },
    getLikes(context, field){
         return new Promise((resolve, reject) => {
            qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(`${field.QnAId}`).collection('Likes').where("Status", "==", 1).get().then(function(snapshot){
                if(snapshot.docs.length)
                {
                    resolve({likes:snapshot.docs.length})
                }
                else
                {
                    resolve({likes:0})
                }
            })
         })
    },
    fetchQnA(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        Name: '',
                        Company: '',
                        CreateDate: '',
                        Designation: '',
                        Email: '',
                        FirstName: '',
                        Group: '',
                        LastModifiedDate: '',
                        LastName: '',
                        Phone: '',
                        Profile: '',
                        ProfilePictureURL: '',
                        QnAId: '',
                        Website: '',
                        IsPublished: true,
                        Resources: [],
                        SocialLinks: [
                            { Facebook: '' },
                            { Twitter: '' },
                            { GooglePlus: '' },
                            { LinkedIn: '' }
                        ],
                    }
                })
            } else {
                let docObj = new Object
                qnaRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    docObj.SocialLinks = {
                        /*Facebook:doc.data().SocialLinks[0].Facebook,
                        Twitter:doc.data().SocialLinks[3].Twitter,
                        GooglePlus:doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn:doc.data().SocialLinks[2].LinkedIn*/
                    }
                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }
                    docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                        //console.log(id)                      
                        resolve({status:200, data:docObj})       
                    
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }
        })
    },
    fetchSingleQnA(context, field) {
        return new Promise((resolve, reject) => {
            qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(field.id).get().then(function(doc) {
                sessionRef.doc(`${field.SessionId}`).get().then(function(session) {
                    let docObj = doc.data()
                    docObj.Session = session.data()
                    resolve(docObj);
                })
            }).catch(function(error) {
                reject(error)
            })
        })
    },
    updateStatusApproved(context, field) {
        return new Promise((resolve, reject) => {
            qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(field.id).update({
                    Approved: field.Approved,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    reject(error)
                })
        })
    },
    updateStatusPublished(context, field) {
        return new Promise((resolve, reject) => {
            qnaRef.doc(`${field.SessionId}`).collection('QnA').doc(field.id).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    reject(error)
                })
        })
    },
    editQuestion(context, field){
        let ls_UserId = ls.getSessionValueByKey('UserId');
         return new Promise((resolve, reject) => {
            let QnAId = field.QnAId
            let SessionId = field.Session.SessionId
            let docObj = {
                //Answer: null,
                //Answered: false,
                Approved: field.qnaValue.Approved,
                //CreatedBy: field.qnaValue.IsAnonymous ? `${ls_UserId}` : `${field.Attendee.AttendeeId}`,
                ModifiedBy: `${ls_UserId}`,
                //CreatedDate: new Date(),
                IsPublished: field.qnaValue.IsPublished,
                IsAnonymous: field.qnaValue.IsAnonymous,
                LastModifiedDate: new Date(),
                //QnAId: QnAId,
                Question: field.qnaValue.Question,
                //SessionId: `${field.Session.SessionId}`,
                //SessionName: `${field.Session.Name}`,
                //TotalDislikes: 0,
                //TotalLikes: 0
            }
            //context.dispatch('getUserDetailById', docObj.CreatedBy).then(userDetail => {
                //docObj.Name = userDetail.Name ? userDetail.Name : null
                //docObj.ProfilePictureURL = userDetail.ProfilePictureURL ? userDetail.ProfilePictureURL : null
                    qnaRef.doc(`${SessionId}`).collection('QnA').doc(`${QnAId}`).update(docObj)
                    .then(function(doc) {
                        resolve({ status: 200, message: 'Data Updated.' });
                    })
            //})
            
        })
    },
    addQuestion(context, field){
        let ls_UserId = ls.getSessionValueByKey('UserId');
         return new Promise((resolve, reject) => {
            let QnAId = "SS" + new Date().getTime();
            let docObj = {
                Answer: null,
                Answered: false,
                Approved: field.qnaValue.Approved,
                CreatedBy: field.Attendee ? `${field.Attendee.AttendeeId}` : `${ls_UserId}`,
                ModifiedBy: field.Attendee ? `${field.Attendee.AttendeeId}` : `${ls_UserId}`,
                CreatedDate: new Date(),
                IsPublished: field.qnaValue.IsPublished,
                IsAnonymous: field.qnaValue.IsAnonymous,
                LastModifiedDate: new Date(),
                QnAId: QnAId,
                Question: field.qnaValue.Question,
                SessionId: `${field.Session.SessionId}`,
                SessionName: `${field.Session.Name}`,
                TotalDislikes: 0,
                TotalLikes: 0
            }
            context.dispatch('getUserDetailById', docObj.CreatedBy).then(userDetail => {
                docObj.Name = userDetail.Name ? userDetail.Name : null
                docObj.ProfilePictureURL = userDetail.ProfilePictureURL ? userDetail.ProfilePictureURL : null
                qnaRef.doc(`${docObj.SessionId}`).set({}).then(function(){
                    qnaRef.doc(`${docObj.SessionId}`).collection('QnA').doc(`${QnAId}`).set(docObj)
                    .then(function(doc) {
                        resolve({ status: 200, message: 'Data Added.' });
                    })
                })
            })
            
        })
    },

    async getAutoId(context) {
        //let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        let AutoId = await promise;
        AutoId = AutoId * 1000;
        return await AutoId.toString();
    },
    generateNumber(context, numberLength) {
        const random = new Random(); // uses the nativeMath engine
        //const value = random.hex(numberLength);
        const value = random.integer(1000, 9999);
        return value.toString();
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('QnA').doc('QnASettings').get().then(function(doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve({ ShowInAttendee: false })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('QnA').doc('QnASettings').get().then(function(doc) {
                if (doc.exists) {
                    con.eventDB.collection(cn).doc("Settings").collection('QnA').doc('QnASettings').update(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                } else {
                    con.eventDB.collection(cn).doc("Settings").collection('QnA').doc('QnASettings').set(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                }

            })
        })
        return promise;
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    let docObj = new Object;
                    docObj[field.fieldName] = field.Status
                    qnaRef.doc(`${data.SessionId}`).collection('QnA').doc(`${data.QnAId}`)
                        .update(docObj)
                        .then(function() {
                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    deleteResource(context, field) {
        return new Promise((resolve, reject) => {
            qnaRef.doc(`${field.id}`).update({                    
                Resources: firebase.firestore.FieldValue.arrayRemove(field.name)                    
            }).then(function(e) {
                resolve({ status: 200, message: 'resource deleted'})
            });
        })
    },
    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }
}